import Vue from 'vue';

import axios from '~/plugins/axios';
import chance from '~/plugins/chance';
import clipboard from '~/plugins/clipboard';
import firebase from '~/plugins/firebase';
import gpu from '~/plugins/gpu';
import html2canvas from '~/plugins/html2canvas';
import jsCookie from '~/plugins/jsCookie';
import jsPDF from '~/plugins/jsPDF';
import marked from '~/plugins/marked';
import moment from '~/plugins/moment';
import oneSignal from'~/plugins/oneSignal';
import video from'~/plugins/video';

import AdminExecuter from '~/plugins/original/AdminExecuter.vue';
import AppExecuter from '~/plugins/original/AppExecuter.vue';
import ArrayExecuter from '~/plugins/original/ArrayExecuter.vue';
import AuthExecuter from '~/plugins/original/AuthExecuter.vue';
import CaseExecuter from '~/plugins/original/CaseExecuter.vue';
import ChanceExecuter from '~/plugins/original/ChanceExecuter.vue';
import ChatExecuter from '~/plugins/original/ChatExecuter.vue';
import ComponentExecuter from '~/plugins/original/ComponentExecuter.vue';
import ContactExecuter from '~/plugins/original/ContactExecuter.vue';
import ContentExecuter from '~/plugins/original/ContentExecuter.vue';
import CookieExecuter from '~/plugins/original/CookieExecuter.vue';
import CriteriumExecuter from '~/plugins/original/CriteriumExecuter.vue';
import CsvExecuter from '~/plugins/original/CsvExecuter.vue';
import DebugExecuter from '~/plugins/original/DebugExecuter.vue';
import EmailLinkExecuter from '~/plugins/original/EmailLinkExecuter.vue';
import FileExecuter from '~/plugins/original/FileExecuter.vue';
import FirestoreExecuter from '~/plugins/original/FirestoreExecuter.vue';
import FormExecuter from '~/plugins/original/FormExecuter.vue';
import FunctionExecuter from '~/plugins/original/FunctionExecuter.vue';
import GpuExecuter from '~/plugins/original/GpuExecuter.vue';
import GroupExecuter from '~/plugins/original/GroupExecuter.vue';
import InitExecuter from '~/plugins/original/InitExecuter.vue';
import InputExecuter from '~/plugins/original/InputExecuter.vue';
import ipcExecuter from '~/plugins/original/IpcExecuter.vue';
import ipCliExecuter from '~/plugins/original/IpCliExecuter.vue';
import LangExecuter from '~/plugins/original/LangExecuter.vue';
import LanguageExecuter from '~/plugins/original/LanguageExecuter.vue';
import LifecycleExecuter from '~/plugins/original/LifecycleExecuter.vue';
import LinkExecuter from '~/plugins/original/LinkExecuter.vue';
import LocalStorageExecuter from '~/plugins/original/LocalStorageExecuter.vue';
import LogExecuter from '~/plugins/original/LogExecuter.vue';
import MenuExecuter from '~/plugins/original/MenuExecuter.vue';
import MessageExecuter from '~/plugins/original/MessageExecuter.vue';
import MomentExecuter from '~/plugins/original/MomentExecuter.vue';
import NotificationExecuter from '~/plugins/original/NotificationExecuter.vue';
import ObjectExecuter from '~/plugins/original/ObjectExecuter.vue';
import OneSignalExecuter from '~/plugins/original/OneSignalExecuter.vue';
import OtpExecuter from '~/plugins/original/OtpExecuter.vue';
import PageExecuter from '~/plugins/original/PageExecuter.vue';
import PointExecuter from '~/plugins/original/PointExecuter.vue';
import ProductExecuter from '~/plugins/original/ProductExecuter.vue';
import PurchaseOrderExecuter from '~/plugins/original/PurchaseOrderExecuter.vue';
import PWAExecuter from '~/plugins/original/PWAExecuter.vue';
import RecruitExecuter from '~/plugins/original/RecruitExecuter.vue';
import SalesExecuter from '~/plugins/original/SalesExecuter.vue';
import SendGridExecuter from '~/plugins/original/SendGridExecuter.vue';
import SmsExecuter from '~/plugins/original/SmsExecuter.vue';
import SnackbarExecuter from '~/plugins/original/SnackbarExecuter.vue';
import StateExecuter from '~/plugins/original/StateExecuter.vue';
import StyleExecuter from '~/plugins/original/StyleExecuter.vue';
import SupplierExecuter from '~/plugins/original/SupplierExecuter.vue';
import ThemeExecuter from '~/plugins/original/ThemeExecuter.vue';
import TimelineExecuter from '~/plugins/original/TimelineExecuter.vue';
import TrainingExecuter from '~/plugins/original/TrainingExecuter.vue';
import TypeExecuter from '~/plugins/original/TypeExecuter.vue';
import UserExecuter from '~/plugins/original/UserExecuter.vue';
import ValidationExecuter from '~/plugins/original/ValidationExecuter.vue';
import VersionExecuter from '~/plugins/original/VersionExecuter.vue';
import VoucherExecuter from '~/plugins/original/VoucherExecuter.vue';
// custom for bri life start
import CustomBriLifeExecuter from '~/plugins/custom/CustomBriLifeExecuter.vue';
// custom for bri life end

Vue.mixin(axios)
Vue.mixin(chance)
Vue.mixin(clipboard)
Vue.mixin(firebase)
Vue.mixin(gpu)
Vue.mixin(html2canvas)
Vue.mixin(jsCookie)
Vue.mixin(jsPDF)
Vue.mixin(marked)
Vue.mixin(moment)
Vue.mixin(oneSignal)
Vue.mixin(video)

Vue.mixin(AdminExecuter)
Vue.mixin(AppExecuter)
Vue.mixin(ArrayExecuter)
Vue.mixin(AuthExecuter)
Vue.mixin(CaseExecuter)
Vue.mixin(ChanceExecuter)
Vue.mixin(ChatExecuter)
Vue.mixin(ComponentExecuter)
Vue.mixin(ContactExecuter)
Vue.mixin(ContentExecuter)
Vue.mixin(CookieExecuter)
Vue.mixin(CriteriumExecuter)
Vue.mixin(CsvExecuter)
Vue.mixin(DebugExecuter)
Vue.mixin(EmailLinkExecuter)
Vue.mixin(FileExecuter)
Vue.mixin(FirestoreExecuter)
Vue.mixin(FormExecuter)
Vue.mixin(FunctionExecuter)
Vue.mixin(GpuExecuter)
Vue.mixin(GroupExecuter)
Vue.mixin(InitExecuter)
Vue.mixin(InputExecuter)
Vue.mixin(ipcExecuter)
Vue.mixin(ipCliExecuter)
Vue.mixin(LangExecuter)
Vue.mixin(LanguageExecuter)
Vue.mixin(LifecycleExecuter)
Vue.mixin(LinkExecuter)
Vue.mixin(LocalStorageExecuter)
Vue.mixin(LogExecuter)
Vue.mixin(MenuExecuter)
Vue.mixin(MessageExecuter)
Vue.mixin(MomentExecuter)
Vue.mixin(NotificationExecuter)
Vue.mixin(ObjectExecuter)
Vue.mixin(OneSignalExecuter)
Vue.mixin(OtpExecuter)
Vue.mixin(PageExecuter)
Vue.mixin(PointExecuter)
Vue.mixin(ProductExecuter)
Vue.mixin(PurchaseOrderExecuter)
Vue.mixin(PWAExecuter)
Vue.mixin(RecruitExecuter)
Vue.mixin(SalesExecuter)
Vue.mixin(SendGridExecuter)
Vue.mixin(SmsExecuter)
Vue.mixin(SnackbarExecuter)
Vue.mixin(StateExecuter)
Vue.mixin(StyleExecuter)
Vue.mixin(SupplierExecuter)
Vue.mixin(ThemeExecuter)
Vue.mixin(TimelineExecuter)
Vue.mixin(TrainingExecuter)
Vue.mixin(TypeExecuter)
Vue.mixin(UserExecuter)
Vue.mixin(ValidationExecuter)
Vue.mixin(VersionExecuter)
Vue.mixin(VoucherExecuter)
// custom for bri life start
Vue.mixin(CustomBriLifeExecuter)
// custom for bri life end
